import React from "react";

import Menu from "../../Components/Menu"
import Header from '../../Sections/Header';
import Features from '../../Sections/Features';
import HowItWorks from '../../Sections/Works';
import Staking from '../../Sections/Staking';
import ThreeTogether from '../../Sections/ThreeTogether';
import Partner from '../../Sections/Partner';
import Audit from '../../Sections/Audits';
import Community from '../../Sections/Community';
import Footer from '../../Sections/Footer';

const Home = () => {
    return(
        <div>
            <Menu />
            <Header />
            <Features />
            <HowItWorks />
            <Staking />
            <ThreeTogether />
            <Partner />
            <Audit />
            <Community />
            <Footer />
        </div>
    );
}

export default Home;